import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { UcrSecurityService } from '../core/ucr-security/ucr-security.service';
import { routerTransition } from '../app.router.animations';
import { UserInfo } from '../core/ucr-security/user-info';
import { Roles } from '../core/ucr-security/roles';

@Component({
    selector: 'app-main-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.scss'],
    animations: [routerTransition()],
    host: { '[@routerTransition]': '' }
})
export class MainMenuComponent implements OnInit {
    awaitingApprovalCount: number = undefined;
    readonly roles = Roles;
    userInfo: UserInfo;

    constructor(private ucrSecurityService: UcrSecurityService, private http: HttpClient) {
        this.ucrSecurityService.getUserInfo().subscribe((ui: UserInfo) => {
            this.userInfo = ui;
        });
    }

    ngOnInit(): void {
        //
    }
}
